[
    {
        "itemId": "A1001001A17D21B03659D80406",
        "dms2docId": "947781444_1492763813624_0001",
        "dms2docCond": 1,
        "createTs": "2017-04-21T08:36:59.000+02:00",
        "lastChangedTs": "2017-04-21T08:37:00.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": "ALSP_Novouzatvorene_zmluvy~1.xls",
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11542C67989",
        "dms2docId": "947781444_1492766137696_0001",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:15:42.000+02:00",
        "lastChangedTs": "2017-04-21T09:15:43.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": "ALSP_Novouzatvorene_zmluvy~1.xls",
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11601E55135",
        "dms2docId": "947781444_1492766137696_0001_44",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:01.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:01.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    },
    {
        "itemId": "A1001001A17D21B11601E62395",
        "dms2docId": "947781444_1492766137696_0001_18",
        "dms2docCond": 1,
        "createTs": "2017-04-21T09:16:01.000+02:00",
        "lastChangedTs": "2017-04-21T09:16:01.000+02:00",
        "dms2docBrand": 1,
        "dms2docCategory": 1190,
        "dms2docSpec": null,
        "dms2processStatus": 2,
        "dms2docBrandLabel": "NL - nov\u00e1 produkcia",
        "dms2docCategoryLabel": "Leasing kasko",
        "dms2docCondLabel": "Zaveden\u00fd",
        "dms2processStatusLabel": "Uploader OK",
        "dms2numPz": "7950000004",
        "dms2shortNote": null,
        "dms2secFlag": 3,
        "dms2docType": 20,
        "dms2docPriority": null,
        "dms2secFlagLabel": "D\u00f4vern\u00fd",
        "dms2docTypeLabel": "GatewayIN"
    }
]